<div style="text-align: left; display:inline-block;" *ngIf="ellipsisEntries.length > 0">
	<div style="vertical-align: middle; display: flex;">
		<button type="button" *ngIf="!noBack" (click)="backButtonClick()" class="btn text-primary" style="padding:0px; margin-right:10px; font-size:16px;">
			<i class="icnAngleLeft" style="font-weight: 900; font-size: 18px; "></i>&nbsp;
			<span *ngIf="uiLang==='Espanol'">Regresa</span>
			<span *ngIf="uiLang!=='Espanol'">Back</span>
		</button>

		<div ngbDropdown container="body" [placement]="(forMap)?'bottom-right':'bottom-left'" display="dynamic">
			<div *ngIf="noBack && !forMap" role="button" style="position: relative; display: flex; flex-direction: column; justify-content: center; margin-left: 0.25rem; padding-left: 5px; padding-right: 8px; padding-top: 0; padding-bottom: 0; width: auto;" class="form-control mapSearchBarStyle">
				<i ngbDropdownToggle class="icnEllipsisVertical" style="color: #3ca2df; vertical-align: inherit; margin-bottom: inherit; padding: 0; font-size: 25px; line-height: 30px; transform: translateX(2px);"></i>
			</div>

			<div *ngIf="noBack && forMap" ngbDropdownToggle role="button" style=" border-style: solid; border-width: 1px; border-radius: 3px; border-color: #95a5a6; height: 54px; display: flex; flex-direction: column; justify-content: center;" class="form-control">
				<i class="icnEllipsisVertical jmPrimaryForeground" style="font-size: 25px;"></i>
			</div>

			<ng-container *ngIf="!noBack">
				<i ngbDropdownToggle role="button" class="icnEllipsisVertical text-primary" style="vertical-align: inherit; margin-bottom: inherit; padding-left: inherit; line-height: 30px;"></i>
			</ng-container>

			<ul ngbDropdownMenu [ngClass]="(forMap)?(noBack)?'without-back':'with-back' :(noBack)?'without-back':'with-back'" [style.min-width]="dropdownWidth" [style.width]="dropdownWidth" [style.transform]="(forMap)?'translate3d(0px, 10px, 0px)':'translate3d(-60px, 10px, 0px)'">
				<li [ngClass]="!noBack?'arrow-up-custom-ellipsis-with-back':'arrow-up-custom-ellipsis-right-justified'"></li>
				<li *ngIf="ellipsisEntries.length === 0" style="padding-bottom: 8px; padding-left: 15px; padding-right: 15px; padding-top: 8px;cursor: default;">Return to this space to see where you have visited during this session!</li>

				<li *ngFor="let ellipsisEntry of ellipsisEntries" style="border-color: rgb(204, 204, 204); border-bottom-width: 1px; border-bottom-style: solid;">
					<div style="padding-bottom: 8px; padding-top: 8px; cursor: default;">
						<ul style="padding: 0; display:inline;">
							<li *ngFor="let link of ellipsisEntry.links; last as isLast; let i = index;" style="display: inline-block; list-style: none; padding-left: 5px; padding-right: 5px; white-space: normal; overflow: auto;">
								<div *ngIf="i===0" div style="display: inline-block; margin-right: 10px; color: rgba(52, 73, 94, 0.75);">{{ellipsisEntry.headerName}}</div>
								<a href="javascript:void(0)" (click)="ellipsisClick(ellipsisEntry, link.linkUrl)" class="text-primary">{{link.linkName}}</a>
								<span *ngIf="!isLast && ellipsisEntry.links.length > 1" style="color:rgba(52, 73, 94, 0.75)"> &gt; </span>
							</li>
						</ul>
					</div>
				</li>

				<li *ngIf="ellipsisEntries.length > 0 && !userInfo.isAnonymous()" ngbDropdownItem>
					<div style="padding: 8px 0px;">
						<a href="javascript:void(0)" (click)="goViewAll($event)" class="text-primary">View All</a>
					</div>
				</li>
			</ul>
		</div>
	</div>
</div>
